import './Drawer.scss';

import Close from "@mui/icons-material/Close";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { closeDrawer } from "../../slices/drawerSlice";

import { IconButton } from "../Buttons/Buttons";

export const Drawer = () => {
    const dispatch = useDispatch();
    const isOpen = useSelector((state) => state.drawer.isOpen);
    const stack = useSelector((state) => state.drawer.stack);

    const current = stack[stack.length - 1] || null;

    if (!isOpen) {
        return null;
    }

    const handleClose = () => {
        dispatch(closeDrawer());
    }

    return (
        <div className="drawer-overlay" onClick={handleClose}>
            <div
                className="drawer-overlay_drawer"
                onClick={(e) => e.stopPropagation()} 
            >
                <div className="drawer-overlay_header">
                    {current?.tools && (
                        <div className="drawer_tools">
                            {current.tools}
                        </div>
                    )}

                    <div className="drawer_close">
                        <IconButton Icon={Close} onClick={handleClose} />
                    </div>
                </div>

                {current?.content && (
                    <div className="drawer-overlay_content">
                        {current.content}
                    </div>
                )}

                {current?.footer && (
                    <div className="drawer-overlay_footer">
                        {current.footer}
                    </div>
                )}
            </div>
        </div>
    );
}